import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=476ceb7a&scoped=true&lang=pug&"
import script from "./UploadVideo.vue?vue&type=script&lang=js&"
export * from "./UploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=476ceb7a&prod&lang=sass&"
import style1 from "./UploadVideo.vue?vue&type=style&index=1&id=476ceb7a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ceb7a",
  null
  
)

export default component.exports